import { Field, ErrorMessage } from "formik";
import { JsonEditor } from "json-edit-react";
import { useEffect, useState } from "react";
import { IMAGE_FETCH_URL, IMAGE_URL } from "../../config";
import cameraIcon from "../../assets/icons/camera.svg";
import get from "lodash/get";
import set from "lodash/set";
import { formatUnderscoreToSpace } from "../../utils/text-format";
import deleteIcon from "../../assets/icons/delete-bin.svg";

//two types are required.
//1. text
//2. images
//they could be in any combination: text text image, text image text imgar, text text image image text with an array format

// renderformat values required

const JsonImage = ({
  label = "imageField",
  labelClassName = "",
  name = "imageField",
  className = "",
  previewClassName = "",
  onChange = (name, value) => {},
  value = "",
  ...props
}) => {
  const handleFileChange = async (event, name) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(IMAGE_URL, {
        method: "POST",
        body: formData,
      });

      if (response.status === 200) {
        const data = await response.json();
        const filePath = data?.data?.filePath;
        const fullUrl = filePath.startsWith("http")
          ? filePath
          : `${IMAGE_FETCH_URL}${filePath}`;

        onChange(name, { url: fullUrl, alt: `${file.name}` });

        console.log(
          name,
          { url: fullUrl, alt: `${file.name}` },
          "Upload success",
        );
      } else {
        console.error("Upload failed", response.statusText);
        alert("Image upload failed!");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("An error occurred during upload!");
    }
  };

  const handleRemoveImage = (name) => {
    // set(updatedValues, name, "");
    // form.setValues(updatedValues);
    onChange(name, "");
  };

  return (
    <div className={`flex flex-col col-span-3 gap-1 ${className}`}>
      {name && (
        <label
          htmlFor={name}
          className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${name}`}
        >
          {formatUnderscoreToSpace(name)}
        </label>
      )}
      <div className="">
        {value?.url ? (
          <div className="relative">
            <div className="md:w-[8rem] w-[5rem] md:h-[8.3rem] h-[5.3rem] relative overflow-hidden">
              <img
                src={value.url}
                alt="Uploaded"
                className={`md:w-[8rem] w-[5rem] md:h-[8rem] h-[5rem] rounded-lg ${previewClassName}`}
              />
              <button
                type="button"
                onClick={() => handleRemoveImage(name)}
                className="absolute top-0 right-0 bg-gray-400 text-white rounded-full p-[1px] px-[6px] text-xs hover:bg-gray-600"
                title="Remove image"
              >
                x
              </button>
            </div>
            <div className={`flex flex-col gap-1 col-span-3 ${className}`}>
              <label
                htmlFor={name + "_alt"}
                className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${name + "_alt"}`}
              >
                {formatUnderscoreToSpace(name + "_alt")}
              </label>
              <input
                id={name + "_alt"}
                name={name + "_alt"}
                value={value.alt}
                onChange={(e) => {
                  onChange(name, { ...value, alt: e.target.value });
                }}
                className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
                                text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
                required
              />
            </div>
          </div>
        ) : (
          <label>
            <div
              className={`border-[1.5px] md:w-[8rem] w-[5rem] md:h-[8rem] h-[5rem] flex items-center justify-center rounded-lg my-1 bg-white border-greyText `}
            >
              <img src={cameraIcon} alt="Camera" />
            </div>
            <input
              name="file"
              type="file"
              className="invisible"
              accept="image/*"
              onChange={(event) => handleFileChange(event, name)}
            />
          </label>
        )}
      </div>
    </div>
  );
};

const JsonFile = ({
  label = "imageField",
  labelClassName = "",
  name = "imageField",
  className = "",
  previewClassName = "",
  onChange = (name, value) => {},
  value = "",
  ...props
}) => {
  const handleFileChange = async (event, name) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(IMAGE_URL, {
        method: "POST",
        body: formData,
      });

      if (response.status === 200) {
        const data = await response.json();
        const filePath = data?.data?.filePath;
        const fullUrl = filePath.startsWith("http")
          ? filePath
          : `${IMAGE_FETCH_URL}${filePath}`;

        onChange(name, fullUrl);

        console.log(name, fullUrl, "Upload success");
      } else {
        console.error("Upload failed", response.statusText);
        alert("Image upload failed!");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("An error occurred during upload!");
    }
  };

  const handleRemoveFile = (name) => {
    // set(updatedValues, name, "");
    // form.setValues(updatedValues);
    onChange(name, "");
  };

  return (
    <div className={`flex flex-col col-span-3 gap-1 ${className}`}>
      {name && (
        <label
          htmlFor={name}
          className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${name}`}
        >
          {formatUnderscoreToSpace(name)}
        </label>
      )}
      <div className="md:h-[8.3rem] h-[5.3rem] relative overflow-hidden">
        {value ? (
          <div className="relative">
            <span className="text-sm text-gray-800 truncate">{value}</span>
            <button
              type="button"
              onClick={() => handleRemoveFile(name)}
              className="absolute top-0 right-0 bg-gray-400 text-white rounded-full p-[1px] px-[6px] text-xs hover:bg-gray-600"
              title="Remove image"
            >
              x
            </button>
          </div>
        ) : (
          <label>
            <div
              className={`border-[1.5px] border-dashed rounded-md px-4 py-2 text-gray-600 hover:bg-gray-50 ${"border-gray-400"}`}
            >
              Choose File
            </div>
            <input
              type="file"
              accept={"*"}
              className="hidden"
              onChange={(event) => handleFileChange(event, name)}
            />
          </label>
        )}
      </div>
    </div>
  );
};

const JsonText = ({
  name = "imageField",
  className = "",
  previewClassName = "",
  onChange = (name, value) => {},
  value = "",
  ...props
}) => {
  return (
    <div className={`flex flex-col gap-1 col-span-3 ${className}`}>
      {name && (
        <label
          htmlFor={name}
          className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${name}`}
        >
          {formatUnderscoreToSpace(name)}
        </label>
      )}
      <input
        id={name}
        name={name}
        value={value}
        onChange={(e) => {
          onChange(name, e.target.value);
        }}
        className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
      />
    </div>
  );
};

const JsonTextArea = ({
  name = "imageField",
  className = "",
  previewClassName = "",
  onChange = (name, value) => {},
  value = "",
  ...props
}) => {
  return (
    <div className={`flex flex-col gap-1 col-span-3 ${className}`}>
      {name && (
        <label
          htmlFor={name}
          className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${name}`}
        >
          {formatUnderscoreToSpace(name)}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={(e) => {
          onChange(name, e.target.value);
        }}
        className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
      />
    </div>
  );
};

const JsonKeyValue = ({
  name = "key_value",
  className = "",
  previewClassName = "",
  onChange = (name, value) => {},
  value = [],
  ...props
}) => {
  const [rowValues, setRowValues] = useState([]);

  useEffect(() => {
    // var jsonfeild = {};
    // for (let index = 0; index < dynamicArrayfeilds.length; index++) {
    //     const element = dynamicArrayfeilds[index];
    //     jsonfeild[element.name] = "";
    // }

    if (value != null && value.length > 0) {
      setRowValues([...value]);
    }
  }, []);

  const addRow = () => {
    const rows = [...rowValues];
    rows.push({ name: "", value: "" });
    setRowValues([...rows]);
    onChange(name, rows);
    // onChange(rows, form);
  };
  const removewRow = (rindex) => {
    var rows = [];
    for (let index = 0; index < rowValues.length; index++) {
      const element = rowValues[index];
      if (index != rindex) {
        rows.push(element);
      }
    }
    setRowValues([...rows]);
    onChange(name, rows);

    // onChange(rows, form);
  };

  const onChangeValues = (rname, rvalue, index) => {
    const rows = [...rowValues];
    console.log("rows before", rows);

    rows[index][rname] = rvalue;
    console.log("rows fater", rows);

    setRowValues([...rows]);

    onChange(name, rows);
  };

  return (
    <div className={`flex flex-col gap-1 col-span-6 ${className}`}>
      {name && (
        <label
          htmlFor={name}
          className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${name}`}
        >
          {formatUnderscoreToSpace(name)}
        </label>
      )}

      {rowValues.map((row, index) => {
        return (
          <div className="flex flex-row gap-2" key={`${name}${index}`}>
            <input
              id={`${name}${index}key`}
              name={`${name}${index}key`}
              value={row.name}
              onChange={(e) => {
                onChangeValues("name", e.target.value, index);
              }}
              className={` px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
                        text-fs_14 text-darkText  placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
            />
            <input
              id={`${name}${index}value`}
              name={`${name}${index}value`}
              value={row.value}
              onChange={(e) => {
                onChangeValues("value", e.target.value, index);
              }}
              className={` px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
                        text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none border-greyText`}
            />
            <button
              type="button"
              onClick={() => {
                removewRow(index);
              }}
              className="w-12 text-red-500 text-xs cursor-pointer p-1 rounded-full shadow-sm justify-self-end opacity-60 bg-errorColor"
            >
              <img src={deleteIcon} width={14} height={14} />
            </button>
          </div>
        );
      })}

      <button
        type="button"
        className="bg-secondary text-white font-bold py-2 px-4 mt-2 rounded text-fs_14"
        onClick={addRow}
      >
        Add specification
      </button>
    </div>
  );
};

const DynamicArrayJson = ({
  label = "JSON Editor",
  labelClassName = "",
  name = "jsonField",
  className = "",
  required = false,
  value = [],
  dynamicArrayfeilds,
  ...props
}) => {
  const [rowValues, setRowValues] = useState([]);

  useEffect(() => {
    // var jsonfeild = {};
    // for (let index = 0; index < dynamicArrayfeilds.length; index++) {
    //     const element = dynamicArrayfeilds[index];
    //     jsonfeild[element.name] = "";
    // }
    var rows = [];
    if (value != null && value.length > 0) {
      for (let index = 0; index < value.length; index++) {
        const valueRow = value[index];

        const deepCopy = structuredClone(dynamicArrayfeilds);
        for (let j = 0; j < deepCopy.length; j++) {
          const column = deepCopy[j];
          column.value = valueRow[column.name] ?? "";
        }
        rows.push(deepCopy);
      }
      setRowValues([...rows]);
      console.log("rows", rows);
    }
  }, []);

  useEffect(() => {
    console.log("rowValues", rowValues);
  }, [rowValues]);
  const addRow = () => {
    var rows = [...rowValues];
    const deepCopy = structuredClone(dynamicArrayfeilds);
    rows.push([...deepCopy]);
    setRowValues([...rows]);
  };
  const removewRow = (rindex, form) => {
    var rows = [];
    for (let index = 0; index < rowValues.length; index++) {
      const element = rowValues[index];
      if (index != rindex) {
        rows.push(element);
      }
    }
    setRowValues([...rows]);
    setFromValues(rows, form);
  };

  const setFromValues = (values, form) => {
    var rows = [];
    for (let index = 0; index < values.length; index++) {
      const row = values[index];
      const obj = {};
      for (let j = 0; j < row.length; j++) {
        const element = row[j];
        obj[element.name] = element.value ?? "";
      }
      rows.push(obj);
    }
    console.log("rows form", rows);

    form.setFieldValue(name, rows);
  };
  const rowRender = (row, rindex, form) => {
    const columns = [];
    for (let index = 0; index < row.length; index++) {
      const element = row[index];
      if (element.type == "text") {
        columns.push(
          <JsonText
            key={`${name}${rindex}${index}`}
            name={element.name}
            value={element?.value}
            onChange={(rname, value) => {
              const rows = [...rowValues];
              console.log("rows before", rows);

              rows[rindex][index].value = value;
              console.log("rows fater", rows);

              setRowValues([...rows]);
              setFromValues(rows, form);
            }}
          />,
        );
      }
      if (element.type == "image") {
        columns.push(
          <JsonImage
            key={`${name}${rindex}${index}`}
            name={element.name}
            value={element?.value}
            onChange={(rname, value) => {
              const rows = [...rowValues];
              rows[rindex][index].value = value;
              setRowValues([...rows]);
              setFromValues(rows, form);
            }}
          />,
        );
      }
      if (element.type == "textarea") {
        columns.push(
          <JsonTextArea
            key={`${name}${rindex}${index}`}
            name={element.name}
            value={element?.value}
            onChange={(rname, value) => {
              const rows = [...rowValues];
              console.log("rows before", rows);

              rows[rindex][index].value = value;
              console.log("rows fater", rows);

              setRowValues([...rows]);
              setFromValues(rows, form);
            }}
          />,
        );
      }

      if (element.type == "key_value") {
        columns.push(
          <JsonKeyValue
            key={`${name}${rindex}${index}`}
            name={element.name}
            value={element?.value}
            onChange={(rname, value) => {
              const rows = [...rowValues];
              console.log("rows before", rows);

              rows[rindex][index].value = value;
              console.log("rows fater", rows);

              setRowValues([...rows]);
              setFromValues(rows, form);
            }}
          />,
        );
      }
      if (element.type == "file") {
        columns.push(
          <JsonFile
            key={`${name}${rindex}${index}`}
            name={element.name}
            value={element?.value}
            onChange={(rname, value) => {
              const rows = [...rowValues];
              console.log("rows before", rows);

              rows[rindex][index].value = value;
              console.log("rows fater", rows);

              setRowValues([...rows]);
              setFromValues(rows, form);
            }}
          />,
        );
      }
    }

    return columns;
  };

  return (
    <div className="w-full">
      <Field name={name}>
        {({ field, form, meta }) => {
          return (
            <div className={`flex flex-col gap-1 ${className}`}>
              {label && (
                <label
                  htmlFor={name}
                  className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${
                    meta.touched && meta.error
                      ? "text-errorColor"
                      : labelClassName
                  }`}
                >
                  {formatUnderscoreToSpace(label)}
                  {required && <span className="text-red-500">*</span>}
                </label>
              )}

              {rowValues.map((item, index) => {
                console.log("item", item);

                const rows = rowRender(item, index, form);
                return (
                  <div
                    key={`${name}${index}`}
                    className={`border rounded-lg overflow-auto ${
                      meta.touched && meta.error
                        ? "border-errorColor"
                        : "border-greyText"
                    }`}
                  >
                    <div className="grid grid-cols-6 gap-2 p-3">
                      {rows.map((row, i) => {
                        return row;
                      })}
                    </div>
                    <div className="flex w-full justify-end pr-5 pb-3">
                      <button
                        type="button"
                        onClick={() => {
                          removewRow(index, form);
                        }}
                        className="text-red-500 text-xs cursor-pointer p-1 rounded-full shadow-sm justify-self-end opacity-60 bg-errorColor"
                      >
                        <img src={deleteIcon} width={14} height={14} />
                      </button>
                    </div>
                  </div>
                );
              })}

              <button
                type="button"
                className="bg-secondary text-white font-bold py-2 px-4 mt-2 rounded text-fs_14"
                onClick={addRow}
              >
                Add
              </button>

              {/* <JsonEditor data={value} onChange={handleChange} {...props} /> */}

              <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
                <ErrorMessage name={name} />
              </label>
            </div>
          );
        }}
      </Field>
    </div>
  );
};

export default DynamicArrayJson;
